import { useAuth } from "../auth/auth-provider";

// components
import "./Login.css";
import AuthPilotLogo from "../images/logo_AuthPilot_consiness.png";
import consinessLogo from "../images/consiness-Logo.png";

export default function Login() {
  const { handleEntraIDLogin } = useAuth();

  return (
    <>
      <div className="landing-page">
        <div className="logo-container">
          <img
            src={AuthPilotLogo}
            alt="AuthPilot Logo"
            className="landing-logo"
          />
        </div>
        <div className="loginform-container">
          <img
            src={consinessLogo}
            alt="Consiness Logo"
            className="landing-consiness"
          />
          <button onClick={handleEntraIDLogin}>Login</button>
        </div>
      </div>
    </>
  );
}
